import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { FileText, Edit, Trash2 } from 'lucide-react';

export function DraftsSection({ drafts, onLoadDraft, onDeleteDraft, onBack }) {
  if (drafts.length === 0) return null;

  return (
    <Card className="p-5 border-0 rounded-2xl shadow-lg bg-gradient-to-br from-amber-50 to-amber-100">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-amber-800 flex items-center gap-2">
          <FileText className="w-5 h-5" />
          Saved Drafts
        </h3>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={onBack}
          className="text-amber-600 hover:text-amber-800"
        >
          Back to Loads
        </Button>
      </div>
      <div className="space-y-3">
        {drafts.map((draft) => (
          <div 
            key={draft.draft_id} 
            className="bg-white rounded-xl p-4 shadow-sm border border-amber-200 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-semibold text-slate-900">
                    {draft.client_name || 'No Client Selected'}
                  </span>
                  {draft.vehicle_number && (
                    <span className="text-xs bg-slate-100 px-2 py-0.5 rounded text-slate-600">
                      {draft.vehicle_number}
                    </span>
                  )}
                </div>
                <div className="text-sm text-slate-500">
                  <span>Driver: {draft.driver_name || 'Not specified'}</span>
                  {draft.invoice_amount && (
                    <span className="ml-3">Amount: ₹{parseFloat(draft.invoice_amount).toLocaleString('en-IN')}</span>
                  )}
                </div>
                <div className="text-xs text-amber-600 mt-1">
                  Saved: {new Date(draft.draft_date).toLocaleString('en-IN')}
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <Button 
                  size="sm" 
                  onClick={() => onLoadDraft(draft)}
                  className="bg-amber-500 hover:bg-amber-600 text-white rounded-lg"
                >
                  <Edit className="w-4 h-4 mr-1" />
                  Resume
                </Button>
                <Button 
                  size="sm" 
                  variant="outline"
                  onClick={() => onDeleteDraft(draft.draft_id)}
                  className="rounded-lg text-red-600 hover:text-red-700 hover:bg-red-50 border-red-200"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
